import React from 'react'
import { IFeature, IFeatureGridProps } from './types'
import { GatsbyImage } from 'gatsby-plugin-image'
import { SectionWrapper } from '../Sections'
import { getTailwindGridCol } from './util'
import { prepareData } from 'utils/googleData'

export const MainFeatures = (props: IFeatureGridProps) => {
    return (
        <ul className="p-0" id="features">
            <FeatureGrid {...props} />
        </ul>
    )
}

export const FeatureList = ({ features }: { features: IFeature[] }) => {
    //  if (Array.isArray(FeatureList) {}
    //   if (Array.isArray(features) && features.length == 1) features = features[0]
    return (
        <ul className="m-0 list-none space-y-6 p-0">
            {features &&
                Array.isArray(features) &&
                features.map(({ title, description }) => {
                    return (
                        <li key={title}>
                            <FeatureTitle>{title}</FeatureTitle>
                            <FeatureDescription>{description}</FeatureDescription>
                        </li>
                    )
                })}
        </ul>
    )
}

export const FeatureGrid = (props: IFeatureGridProps) => {
    const { enable, title, subtitle, description, cta, Icon, features, direction, style, gatsbyImage, gatsbyImage2 } =
        prepareData({ props })
    // console.log(`feature props ${JSON.stringify(props)}`)
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    const length = features?.length ?? 1
    return (
        <SectionWrapper dir={direction} className="max-w-full">
            <ul
                className={`max-w-screen-4xl m-0 mx-auto grid list-none space-y-8 p-0 md:space-y-0 ${getTailwindGridCol(
                    length
                )} ${style}`}
            >
                {features?.map((feature) => {
                    return <Feature key={feature.title} {...feature} />
                })}
            </ul>
        </SectionWrapper>
    )
}

export const FeatureTitle = ({ children, className = '' }: { children: React.ReactNode; className?: string }) => (
    <h3 className={`mb-1 text-[17px] leading-tight ${className}`}>{children}</h3>
)

export const FeatureDescription = ({ children, className = '' }: { children: React.ReactNode; className?: string }) => (
    <p className={`m-0 text-[15px] ${className}`}>{children}</p>
)

export const Feature = (props: IFeature) => {
    const { enable, title, description, cta, Icon, direction, style, gatsbyImage } = props
    return (
        <li dir={direction} className={`sm:p-6 sm:pb-8  ${style}`}>
            {Icon && <Icon className="text-gray-800 dark:text-gray-200 mb-4 h-10 w-10" />}
            {gatsbyImage && <GatsbyImage alt={title || ''} image={gatsbyImage} className="mb-4 h-10 w-10 opacity-50" />}
            <FeatureTitle>{title}</FeatureTitle>
            <FeatureDescription>{description}</FeatureDescription>
        </li>
    )
}
